import angular from 'angular';

export default angular.module('app.filters.newline-to-br', []).filter(
  'newlineToBr',
  $sce =>
    function(text) {
      if (text == null) {
        text = '';
      }
      return $sce.trustAsHtml(text.replace(/\n/g, '<br/>'));
    }
);
